"use client";

import React from "react";

const trackGAEvent = (eventName: string, params: Record<string, any>) => {
  if (
    typeof window !== "undefined" &&
    typeof (window as any).gtag === "function"
  ) {
    (window as any).gtag("event", eventName, params);
  }
};

const getWebVersion = () => process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0";

const LandingFooter = () => {
  const webVersion = getWebVersion();
  const socialLinks = [
    {
      name: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61593906447598",
      active: true,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/galura.id2026/",
      active: true,
    },
    {
      name: "WhatsApp",
      href: "https://wa.me/6287895973284",
      active: true,
    },
  ];

  const handleSocialClick = (name: string, href: string) => {
    trackGAEvent("select_content", {
      content_type: "social_media_link",
      item_id: name.toLowerCase(),
      item_name: name,
      destination_url: href,
    });
    trackGAEvent("click_social_link", {
      platform: name,
      url: href,
    });
  };

  return (
    <footer className="relative w-full overflow-hidden bg-green-700 px-10 py-20 dark:bg-slate-800">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/assets/landing/banner/bg-banner-home.webp')",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-green-900/45 dark:bg-slate-950/55" />
      <div className="relative z-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <h3 className="text-lg text-white font-semibold">Alamat</h3>
            <p className="text-[14px] text-slate-100 mt-2 leading-relaxed">
              Kp. Sukamelang, Kel. Andir, Kec. Baleendah No. 54 RT 4 / RW 12
              <br />
              (Rumah pagar hitam seberang rumah orange)
              <br />
              Baleendah, Kab. Bandung
              <br />
              Jawa Barat 40375
            </p>
            <p className="mt-3 text-[14px] text-slate-100">
              <span className="font-semibold text-white">Telp / WA:</span>{" "}
              <a
                href="https://wa.me/6287895973284"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  handleSocialClick(
                    "WhatsApp Phone",
                    "https://wa.me/6287895973284",
                  )
                }
                className="hover:text-emerald-300 underline transition-colors"
              >
                087895973284 (+62 878-9597-3284)
              </a>
            </p>
            <p className="mt-2 text-[14px] text-slate-100">
              <span className="font-semibold text-white">Email:</span>{" "}
              <a
                href="mailto:contact.galura@gmail.com"
                className="hover:text-emerald-300 underline transition-colors"
              >
                contact.galura@gmail.com
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-lg text-white font-semibold">Layanan</h3>
            <ul className="space-y-2 mt-2 text-[14px] text-slate-100">
              <li>Pengembangan Web & Aplikasi</li>
              <li>Konsultasi Transformasi Digital</li>
              <li>Integrasi Sistem</li>
              <li>UI/UX Design</li>
              <li>Pemeliharaan Teknologi</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg text-white font-semibold">Ikuti Kami</h3>
            <ul className="space-y-3 mt-3 text-[14px] text-slate-100">
              {socialLinks.map((item) => (
                <li key={item.name}>
                  {item.active ? (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Ikuti kami di ${item.name}`}
                      onClick={() => handleSocialClick(item.name, item.href)}
                      className="inline-flex items-center gap-2 min-h-[44px] py-1.5 px-3 -mx-3 rounded hover:bg-emerald-800/50 hover:text-emerald-300 hover:underline transition-colors"
                    >
                      <span>{item.name}</span>
                    </a>
                  ) : (
                    <span className="cursor-not-allowed text-slate-200 min-h-[44px] inline-flex items-center">
                      {item.name}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="relative z-10 mt-10 text-center text-[12px] text-white font-medium">
        Web Version v{webVersion}
      </div>
    </footer>
  );
};

export default LandingFooter;
